export interface ModeActionTypes {
  type: ModeActions;
  payload?: any;
}

export enum ModeActions {
  CREATE_MODE = "CREATE_MODE",
  GET_MODE_LIST = "GET_MODE_LIST",
  SET_MODE_LIST = "SET_MODE_LIST",
  SET_MODE_LIST_PAGE_COUNT = "SET_MODE_LIST_PAGE_COUNT",
  GET_MODE_DATA_BY_ID = "GET_MODE_DATA_BY_ID",
  SET_MODE_DATA_BY_ID = "SET_MODE_DATA_BY_ID",
  EDIT_MODE_DATA_BY_ID = "EDIT_MODE_DATA_BY_ID",
}
